import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const BlogpayLoginSchema: FormFieldSchema[] = [
  {
    id: "email",
    label: "블로그페이 이메일",
    placeholder: "블로그페이 이메일을 입력해주세요.",
    type: FormFieldType.Text,
  },
  {
    id: "password",
    label: "블로그페이 비밀번호",
    placeholder: "블로그페이 비밀번호를 입력해주세요.",
    type: FormFieldType.Text,
  },
];
